import { FaWhatsapp, FaEnvelope, FaPhone } from "react-icons/fa";
import { Helmet } from "react-helmet";

function ContactInfo() {
  return(
    <>

<Helmet>
        <title>Contact OGTH – Get in Touch</title>
        <meta
          name="description"
          content="Contact OGTH via email, phone, or WhatsApp to learn more about our programs, partnerships, and opportunities for youth and women in Africa."
        />
        <meta
          name="keywords"
          content="Contact OGTH, email OGTH, OGTH phone, WhatsApp OGTH, Africa youth programs, human capital development"
        />
        <meta property="og:title" content="Contact OGTH – Get in Touch" />
        <meta property="og:description" content="Contact OGTH via email, phone, or WhatsApp to learn more about our programs, partnerships, and opportunities for youth and women in Africa." />
        <meta property="og:image" content="https://yourdomain.com/path-to-contact-image.jpg" />
        <meta property="og:url" content="https://yourdomain.com/contact" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

    <div className="bg-gray-50">
    <div className="bg-gray-50 max-w-5xl mx-auto py-16 px-6">

      <h2 className="text-2xl font-semibold text-center mb-5">
    We are here for you, contact us at anytime. 
</h2>
        <p className="font-bold text-brand-greenText text-center mb-10">Have any questions about our services? please reach out</p>


      <div className="grid md:grid-cols-3 gap-6">

        {/* WhatsApp */}
        <div className="bg-white shadow-md rounded-lg p-6 text-center">
          <FaWhatsapp className="text-4xl text-brand-greenText mx-auto mb-4" />
          <h3 className="text-lg font-semibold mb-2">Chat on WhatsApp</h3>
          <p className="text-gray-600 mb-4">
            Send us a quick message and we'll respond as soon as possible.
          </p>

          <a
            href="https://wa.me/+2348036683621"
            target="_blank"
            rel="noreferrer"
            className="bg-brand-greenText text-white px-4 py-2 rounded-md hover:bg-[#5FA64D] transition"
          >
            Chat Now
          </a>
        </div>

        {/* Email */}
        <div className="bg-white shadow-md rounded-lg p-6 text-center">
          <FaEnvelope className="text-4xl text-brand mx-auto mb-4" />
          <h3 className="text-lg font-semibold mb-2">Email Us</h3>
          <p className="text-gray-600 mb-4">
            Send us an email and we’ll get back to you soon.
          </p>

          <a
            href="mailto:ogth.africa@gmail.com"
            className="bg-brand text-white px-4 py-2 rounded-md hover:bg-[#0B4A73] transition"
          >
            Send Email
          </a>
        </div>

        {/* Call */}
        <div className="bg-white shadow-md rounded-lg p-6 text-center">
          <FaPhone className="text-4xl text-brand-secondary mx-auto mb-4" />
          <h3 className="text-lg font-semibold mb-2">Call Us</h3>
          <p className="text-gray-600 mb-4">
            Prefer to talk? Give us a call directly.
          </p>

          <a
            href="tel:+2348035407137"
            className="bg-brand-secondary text-white px-4 py-2 rounded-md hover:[#3F8FB6] transition"
          >
            Call Now
          </a>
        </div>

      </div>
    </div>
    </div>

    </>
  );
}

export default ContactInfo;